import gql from 'graphql-tag';


export default
gql `mutation updateActivityHelp($input: UpdateActivityInput!){
		updateActivityHelp(input: $input){
            id
            username
            actDate
            activityType
            value
            intensity
            notes
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/mutations/UpdateActivityHelpMutation.js